import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import Card from '../../elements/common/Card';
import { SelectOptions } from '../../elements/formElements/Select';
import { StringParams } from '../../helpers/types';
import useOnce from '../../hooks/useOnce';
import axios from '../../services/MyAxios';

import AttachForm from './AttachForm';

type Props = {
    root?: string;
    id?: string;
    setWasAttached?: (value: boolean) => void;
};

function AttachPermission({ root, id, setWasAttached }: Props) {
    const { root: paramRoot, id: paramId } = useParams<StringParams>();
    const finalRoot = root || paramRoot;
    const finalId = id || paramId;
    const [options, setOptions] = useState<SelectOptions>({});
    const url = `/crea/api/${finalRoot}/${finalId}`;

    const handleAttach = async (permission: string) => {
        await axios.post(`${url}/permissions/attach`, { permission });
        if (setWasAttached) setWasAttached(true);
    };

    useOnce(async () => {
        const list = (await CRMApi.get('permissions_short')).data;
        const sorted = Object.entries(list).sort((a, b) => String(a[1]).localeCompare(String(b[1])));
        setOptions(sorted as SelectOptions);
    });

    return (
        <Card title="Attach Permission">
            <AttachForm action={handleAttach} selectElements={options} field="permission" title="Permission" />
        </Card>
    );
}

export default AttachPermission;
